export const WORLD_IDENTITY_V2 = Object.freeze({
  version: 2,
  worldOrder: Object.freeze([
    'aries', 'taurus', 'gemini', 'cancer', 'leo', 'virgo',
    'libra', 'scorpio', 'sagittarius', 'capricorn', 'aquarius', 'pisces',
  ]),
  worldElements: Object.freeze([
    'fire', 'earth', 'air', 'water', 'fire', 'earth',
    'air', 'water', 'fire', 'earth', 'air', 'water',
  ]),
  initialBias: Object.freeze({ early: 0.70, mid: 0.62, late: 0.55 }),
  refillBias: 0.425,
  openingMoveRequirement: 'match_contains_world_element',
  goalFamilies: Object.freeze({
    fire: Object.freeze(['clear_element', 'combos', 'specials', 'score']),
    earth: Object.freeze(['controlled_clear', 'score_efficiency', 'precision']),
    air: Object.freeze(['multi_element', 'cascades', 'directional_specials']),
    water: Object.freeze(['cascades', 'chain_clears', 'clear_element']),
  }),
  signGoalFlavor: Object.freeze({
    aries: 'aggressive', leo: 'specials', sagittarius: 'combos',
    taurus: 'efficiency', virgo: 'precision', capricorn: 'precision',
    gemini: 'variety', libra: 'directional', aquarius: 'multi_element',
    cancer: 'chain', scorpio: 'deep_cascade', pisces: 'sustained',
  }),
});

export function worldIdentityBias(indexInWorld) {
  const n = Number(indexInWorld) || 1;
  return n <= 5 ? WORLD_IDENTITY_V2.initialBias.early : (n <= 12 ? WORLD_IDENTITY_V2.initialBias.mid : WORLD_IDENTITY_V2.initialBias.late);
}

export function worldIdentityElement(worldIndex) {
  return WORLD_IDENTITY_V2.worldElements[Number(worldIndex)] || null;
}

export function getWorldGoalFamily(element) {
  return WORLD_IDENTITY_V2.goalFamilies[element] || WORLD_IDENTITY_V2.goalFamilies.fire;
}

export function getWorldSignFlavor(signKey) {
  return WORLD_IDENTITY_V2.signGoalFlavor[String(signKey || '').toLowerCase()] || 'balanced';
}
